import { createSlice } from "@reduxjs/toolkit";
import { post } from "../api/http";
import ServerRoutes from "../api/routes";

const initialState = {
  invitation: null,
  invitationError: null,
  invitationLoading: false,
};

const _actionStart = (state) => {
  state.invitationLoading = true;
  state.invitationError = null;
};

const _actionSuccess = (state) => {
  state.invitationLoading = false;
  state.invitationError = null;
};

const _actionFailed = (state, action) => {
  state.invitationLoading = false;
  state.invitationError = action.payload.error;
};

const _setInvitation = (state, action) => {
  state.invitation = action.payload;
};

const _cleanInvitationState = (state) => {
  state.invitation = null;
  state.invitationError = null;
  state.invitationLoading = false;
};

const invitation = createSlice({
  name: "invitation",
  initialState,
  reducers: {
    cleanInvitationState: _cleanInvitationState,
    setInvitation: _setInvitation,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = invitation;

const {
  actionStart,
  actionFailed,
  actionSuccess,
  setInvitation,
  cleanInvitationState,
} = actions;

export default reducer;

export const cleanAll = () => {
  return async (dispatch) => {
    return dispatch(cleanInvitationState());
  };
};

export const getInvitationDetails = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.User.getInvitationDetails,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setInvitation(data));
    }
  };
};

export const getInvitationDetailsSelf = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.User.getInvitationDetailsSelf,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setInvitation(data));
    }
  };
};
